import axios from 'axios'

const { NODE_ENV, VUE_APP_PROXY_PREFIX, VUE_APP_BASE_URL } = process.env
const baseURL = NODE_ENV === 'development' ? VUE_APP_PROXY_PREFIX : VUE_APP_BASE_URL

const service = axios.create({
  baseURL
})

const resCode = {
  success: 200 // 接口请求成功
}

service.interceptors.request.use(
  config => {
    config.withCredentials = true
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

service.interceptors.response.use(
  response => {

    // console.log(response, 'response');

    if (response.status === 200) {
      const { code } = response.data
      switch (code) {
        case resCode.success:
          return response.data
        default:
          throw response.data
      }
    } else {
      throw response.data
    }
  },
  err => {
    throw err
  }
)
export default service
